import React, { useEffect } from 'react';
import I18n from 'utils/I18n';
import { trackV2 } from 'utils/analytics';
import Cldr from 'utils/Cldr';
import Card from '../shared/Card';
import Inset from '../shared/Inset';
import { useCheckoutContext } from '../../state/CheckoutContext';
import { I18nPrefixHoliday } from '../../shared/constants';
import styles from './SummaryHoliday.scss';

const SummaryHoliday = () => {
  const { checkoutEntityState } = useCheckoutContext();
  const { analyticsData, pricing } = checkoutEntityState;
  const { currency, billedToday } = pricing;

  useEffect(() => {
    const trackProps = {
      category: 'subscriptions',
      page: 'holiday_2022_checkout',
      properties: {
        ...analyticsData,
        subscription_type: 'organic'
      }
    };
    trackV2({ ...trackProps, action: 'screen_enter' });
    return () => {
      trackV2({ ...trackProps, action: 'screen_exit' });
    };
  }, [analyticsData]);

  const renderPerYearPrice = (price) =>
    I18n.t_html(
      `${I18nPrefixHoliday}.per_year_v2`,
      {
        price: Cldr.formatCurrency(price, currency)
      },
      {
        tagName: 'div'
      }
    );

  const getAutoRenewDate = () => {
    const autoRenewDate = new Date();
    // auto renew date is 14 months from today (buy 12, get 2 free)
    autoRenewDate.setMonth(autoRenewDate.getMonth() + 14);
    return Cldr.formatDateTime(autoRenewDate, {
      format: 'additional',
      type: 'yMMMd'
    });
  };

  return (
    <div className={styles.checkoutSummary}>
      <Card>
        <Inset>
          <div className={styles.overviewContainer}>
            <h5 className="text-bold">
              {I18n.t(`${I18nPrefixHoliday}.offer`)}
            </h5>
            <h6>{renderPerYearPrice(billedToday)}</h6>
          </div>
        </Inset>
        <Inset transparent={false} className={styles.topBorder}>
          <div className={styles.pricingContainer}>
            <h4 className={`text-bold ${styles.pricingRow}`}>
              <p>{I18n.t(`${I18nPrefixHoliday}.billed_today`)}</p>
              <p>{renderPerYearPrice(billedToday)}</p>
            </h4>
            <small className={`text-caption1 ${styles.pricingFooter}`}>
              {I18n.t(`${I18nPrefixHoliday}.cancel`)}
            </small>
          </div>
        </Inset>
        <Inset>
          <div className={styles.footerContainer} data-testid="footer">
            <div className={`text-footnote ${styles.footerRow}`}>
              <p>
                {I18n.t(`${I18nPrefixHoliday}.footnote_v2`, {
                  date: getAutoRenewDate()
                })}
              </p>
            </div>
          </div>
        </Inset>
      </Card>
    </div>
  );
};

export default SummaryHoliday;
